import gql from "graphql-tag";
import { OFFERS_FRAGMENT } from "../offer/fragment";
import { COMPANY_FRAGMENT } from "../company/fragments";
import { USER_FRAGMENT } from "../user/fragment";

export const ONBOARDING = gql`
  query OnboardingInfo {
    onboardingInfo {
      offer {
        ...OffersInfo
      }
      company {
        ...CompanyInfo
      }
      legalRepresentative {
        ...UserInfo
      }
      users {
        ...UserInfo
      }
    }
  }
  ${OFFERS_FRAGMENT}
  ${COMPANY_FRAGMENT}
  ${USER_FRAGMENT}
  ${USER_FRAGMENT}
`;

export const AUTO_COMPLETION = gql`
  query AutoCompletion {
    autoCompletion
  }
`;

export const GET_ID = gql`
  query GetID {
    getID
  }
`;
